// TSS vite/02 — centralized constants.
// Section ids double as URL hashes (/#servicios), so renaming one breaks shared links.

export const ROUTES = {
    HOME:    '/',
    PRIVACY: '/politica-de-datos',
};

export const SECTION_IDS = {
    SERVICES:  'servicios',
    PROCESS:   'proceso',
    SOLUTIONS: 'soluciones',
    ABOUT:     'nosotros',
    FAQ:       'preguntas',
    CONTACT:   'contacto',
};

export const NAV_LINKS = [
    { id: SECTION_IDS.SERVICES,  label: 'Servicios' },
    { id: SECTION_IDS.PROCESS,   label: 'Cómo trabajamos' },
    { id: SECTION_IDS.SOLUTIONS, label: 'Soluciones' },
    { id: SECTION_IDS.ABOUT,     label: 'Nosotros' },
    { id: SECTION_IDS.FAQ,       label: 'Preguntas' },
];

export const NAV_SECTION_IDS = NAV_LINKS.map(link => link.id);

export const SERVICE_QUERY_PARAM = 'servicio';
